export const EventActionTypes = {
    API_RESPONSE_SUCCESS: '@@event/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@event/API_RESPONSE_ERROR',

    LIST_EVENT: '@@event/LIST_EVENT',
    SHOW_EVENT: '@@event/SHOW_EVENT',
    FILTER_EVENT: '@@event/FILTER_EVENT',
};